module.exports = __webpack_public_path__ + "static/img/portfolio2.afd01b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/portfolio2.jpg
// module id = PrDS
// module chunks = 0